import { CircularLoader } from '@modules/common/components/CircularLoader';
import { LazyLoadVirtualList } from '@modules/common/components/LazyLoadVirtualList';
import { Box } from '@mui/material';
import { SyntheticEvent } from 'react';
import { CollectionItem } from '../../../types';
import { CollectionListItem } from '../CollectionListItem';

interface CollectionListProps {
  collections: CollectionItem[];
  fetchMore: () => Promise<void>;
  hasNextPage: boolean;
  isLoadingFirstPage: boolean;
  feedbackID: string;
  onMenuClose: (event: SyntheticEvent) => void;
}

export const CollectionList = ({
  collections,
  fetchMore,
  hasNextPage,
  isLoadingFirstPage,
  feedbackID,
  onMenuClose,
}: CollectionListProps) => {
  const renderCollectionListItem = (collectionItem: CollectionItem) => {
    return (
      <CollectionListItem
        key={collectionItem.id}
        collectionItem={collectionItem}
        feedbackID={feedbackID}
        onMenuClose={onMenuClose}
      />
    );
  };

  if (isLoadingFirstPage) {
    return (
      <CircularLoader
        stackProps={{
          height: 230,
        }}
        size={20}
      />
    );
  }

  return (
    <Box height={230} overflow="auto">
      <LazyLoadVirtualList
        data={collections}
        loadMoreItems={fetchMore}
        listHeight={230}
        defaultListItemHeight={43}
        renderRowComponent={renderCollectionListItem}
        hasNextPage={hasNextPage}
      />
    </Box>
  );
};
